import { useState, useEffect } from 'react';
import { fetchAreasNotCoveringDateRange } from '../../../services/b2b-plans-apiService';
import { useLoginContext } from '../../../App';

/**
 * Hook to fetch areas that don't cover a specific date range
 * @param {Date} minDate - The minimum date of the range
 * @param {Date} maxDate - The maximum date of the range
 * @returns {Object} Object containing areaIds array, loading state, and error state
 */
const useAreasNotCoveringDateRange = (minDate, maxDate) => {
    const { loginData } = useLoginContext();
    const [areaIds, setAreaIds] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchAreasNotCovering = async () => {
        // Don't fetch if dates are not provided
        if (!minDate || !maxDate) {
            setAreaIds([]);
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const response = await fetchAreasNotCoveringDateRange(loginData.accessToken, minDate, maxDate);
            // Assuming the response contains an array of area objects with areaId property
            const ids = response.map(areaId => areaId);
            setAreaIds(ids);
        } catch (err) {
            console.error('Error fetching areas not covering date range:', err);
            setError(err);
            setAreaIds([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAreasNotCovering();
    }, [minDate, maxDate]);

    return {
        areaIds,
        loading,
        error,
        refetch: fetchAreasNotCovering
    };
};

export default useAreasNotCoveringDateRange;
